import { Box, Button, Typography } from '@mui/material';
import { legalApproval } from 'API/compassRights';
import { DynamicArrow } from 'Components/DynamicArrow';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IUserApproval {
  setModalAgreementBox: Function;
  userAgreement: boolean;
  setShowAgreementErrorMessage: Function;
  modalRef: any;
}

export const UserApproval = ({
  setModalAgreementBox,
  userAgreement,
  setShowAgreementErrorMessage,
  modalRef,
}: IUserApproval) => {
  const isDesktop = useIsDesktop();

  async function modalAgreement() {
    if (userAgreement) {
      setModalAgreementBox(true);

      await legalApproval();
    } else {
      setShowAgreementErrorMessage(true);
    }
  }

  // Blocks forward tab navigation to the background html elements.
  const accessibilityBackgroundBlockHandler = (event: any) => {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      modalRef.current.focus();
    } else onEnterOrEscapeKeyDown(event);
  };
  return (
    <Button
      role='button'
      variant='primary'
      sx={{
        borderRadius: '100px',
        whiteSpace: 'nowrap',
        width: isDesktop ? '234px' : '208px',
        height: isDesktop ? 'auto' : '44px',
        padding: isDesktop ? '12px 24px' : '10px 24px',
        gap: isDesktop ? '4px' : '10px',
        zIndex: 1,
      }}
      onClick={modalAgreement}
      onKeyDown={accessibilityBackgroundBlockHandler}
    >
      <Typography variant={'body4'} color={'#fff'}>
        {
          Dictionary[DICTIONARY.CompassRights].agreementModal
            .sendRequestAgreement
        }
      </Typography>
      <Box
        sx={{
          transform: 'rotate(90deg)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <DynamicArrow color={'#fff'} />
      </Box>
    </Button>
  );
};
